import script from "./CommonInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommonInput.vue?vue&type=script&setup=true&lang=ts"

import "./CommonInput.vue?vue&type=style&index=0&id=4dd93420&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dd93420"]])

export default __exports__